export default {
  NAVIGATION_GLOBAL_ID: 'nav-menu',
  PAGE_LINK_REGEXP: /^\/([^/]|$)/,
  SUBMENU_SELECTOR: '.ws-nav__submenu-list',
  MENU_ITEM_CLASS: 'ws-nav__menu-list-item',
  SUBMENU_ITEM_CLASS: 'ws-nav__submenu-list-item',
  LINK_SELECTOR: 'a',
  TEXT_SELECTOR: 'span',
  NAVIGATION_ITEM_TEMPLATE: `<li class="ws-nav__menu-list-item"><a class="ws-nav__menu-link"><span></span></a></li>`,
};
